import { mapValues, some } from "lodash-es";
const needConvertVWVH = uc => {
  var _uc$designer;
  return uc === null || uc === void 0 || (_uc$designer = uc.designer) === null || _uc$designer === void 0 ? void 0 : _uc$designer.editSize;
};
const hasVWVH = value => typeof value === 'string' && /\b\d+(\.\d+)?(vw|vh)\b/.test(value);
function convertVWVHString(value, uc) {
  if (typeof value !== 'string') return value;
  const editSize = needConvertVWVH(uc);
  if (!editSize) return value;
  return value.replace(/\b(\d+(\.\d+)?)(vw|vh)\b/g, (_x, num, _decimal, unit) => {
    if (unit === 'vw') {
      return `${parseFloat(num) * 0.01 * editSize.width}px`;
    }
    return `${parseFloat(num) * 0.01 * editSize.height}px`;
  });
}
export function hookVWVHConvert(uc) {
  if (!uc.isDesignMode) return; // 这个插件仅设计模式下用
  uc.hooks.beforeConvertStyle.tap('StyleConvertPlugin', (style, ctx) => {
    const {
      uc
    } = ctx;
    const needConvert = needConvertVWVH(uc) && some(style, hasVWVH);
    return needConvert;
  });
  uc.hooks.convertStyle.tap('StyleConvertPlugin', (style, ctx) => {
    const style2 = mapValues(style, value => convertVWVHString(value, ctx.uc));
    return style2;
  });
}